export default __webpack_public_path__ + "static/air-ambulance-36f347a9c750493d557c96de1a1a964c.jpg";